import { createBrowserRouter } from "react-router-dom"

import { App } from "App"
import { SelectTickets } from "pages/select-tickets/select-tickets"
import { TicketDetails } from "pages/ticket-details/ticket-details"
import { Success } from "pages/success/success"
import { Checkout } from "pages/checkout/checkout"
import { NotFound } from "components/not-found"
import { OrderNotFound } from "components/order-not-found"

export const router = createBrowserRouter([
  {
    path: ":uuid/",
    element: <App />,
    children: [
      {
        path: "select-tickets",
        element: <SelectTickets />,
      },
      {
        path: "ticket-details",
        element: <TicketDetails />,
      },
      {
        path: "checkout",
        element: <Checkout />,
      },
      {
        path: "success",
        element: <Success />,
      },
      {
        path: "order-not-found",
        element: <OrderNotFound />,
      },
    ],
  },
  { path: "*", element: <NotFound /> },
])
